import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AbouteMe.css';

export default function App() {
  const navigate = useNavigate();

  return (
    <div className="about-me-container">
      <div className="about-me-card">
        
        {/* Քարտի ֆոնային նկար */}
        <img 
          src="./asd.png" 
          alt="" 
          className="about-me-image"
          onError={(e) => {
            e.target.onerror = null; 
            e.target.src = "https://images.unsplash.com/photo-1514933651103-005eec06c04b?q=80&w=1000&auto=format&fit=crop";
          }}
        />
        
        {/* Տեքստ (Bottom Section) */}
        <div className="about-me-content">
          
          <h2 className="about-me-title">
            «Տժվժիկ»
          </h2>
          
          <div className="about-me-text-block">
            <p>
              Ամեն ինչ սկսվել էր մանկությունից։ Ամեն կիրակի մեր տանը տարածվում էր տապակած սոխի, համեմունքների և տաք հացի բույրը։ Հեռուստացույցին՝ սև ու սպիտակ էկրան, և նորից այն ֆիլմը՝ «Տժվժիկը»՝ ծիծաղելի, տխուր, հարազատ։ Այն հասարակության, մարդկայնության, կյանքի հանդեպ սիրո խորհրդանիշ էր անգամ ամենահամեստ պայմաններում։
            </p>
            <p>
              Անցան տարիներ, սակայն այն կերպարները մնացին մեր սրտում։ Եվ ահա մի օր միտք ծագեց ստեղծել մի վայր, որտեղ կարելի է ոչ միայն համեղ ճաշել, այլև զգալ այն հարազատ մթնոլորտը՝ սոխի հոտով, անկյունում դրված հին ձայնարկիչով և հայ ֆիլմի սիրելի դերասանների նկարներով։ Այդպես ծնվեց «Տժվժիկ» ռեստորանը։
            </p>
            <p>
              Սա ուղղակի ռեստորան չէ, սա խոհարարական բեմադրություն է՝ ավանդույթների հանդեպ հարգանքով։ Մենք պատրաստում ենք ճաշատեսակներ, որոնք կարող էին հայտնվել ֆիլմի հերոսների սեղաններին՝ հասարակ, հագեցնող և հոգով։ Մենք օգտագործում ենք միայն թարմ մթերք, տնական բաղադրատոմսեր, շատ կանաչեղեն և իհարկե՝ սեր։
            </p>
            <p>
              Մեզ մոտ իսկապես պատրաստում են հենց այն՝ ֆիլմի տժվժիկը, քանզի «Տժվժիկ»-ը հրավերք է դեպի հիշողություններ։ Այստեղ չեն շտապում, այստեղ ժպտում են, ասում կենացներ, գրկախառնվում և հիշում, թե ինչ կարևոր է ուղղակի մարդ մնալ։
            </p>
            <p className="about-me-welcome">
              Բարի գալուստ տուն։<br/>
              Բարի գալուստ «Տժվժիկ»։
            </p>
            <p className="about-me-footer-text">
              Այս ռեստորանը հին և բարի ֆիլմի պես ջերմ է և լուսառատ, որտեղ համը հիշեցնում է տան մասին։ Մեր ճաշացանկում հայկական և կովկասյան ուտեստներ են, պատրաստված ավանդական բաղադրատոմսով։ Վայելեք մթնոլորտը, հիշեք սիրելի ֆիլմերը և բարձրացրեք բաժակները, զգացեք Ձեզ ինչպես տանը։
            </p>
          </div>

          <div className="about-me-actions">
             {/* CTA կոճակ */}
            <button 
              className="about-me-button"
              onClick={() => navigate("/")}
            >
            Menu
            </button>
            <p className="about-me-service-fee">
              ՍՊԱՍԱՐԿՈՒՄ՝ 10%
            </p>
          </div>
          
        </div>
      </div>
    </div>
  );
}